<h1 class="header-text" [ngStyle]="{ fontSize: currentSize, lineHeight: lineHeight, marginTop: mt, marginBottom: mb}">
    <ng-content></ng-content>
</h1>